import React, { useState, useEffect, useCallback, useRef } from "react";
import backarrow from "../../assets/svg/backarrow.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Button, ProgressBar, Form, Container, Row, Col } from "react-bootstrap";
import { Toast, ToastContainer } from "react-bootstrap";
import upload from "../../assets/svg/upload-img.svg";
import SearchWithAPI from "../searchbox/searchbox.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import reminder from "../../assets/svg/reminder-icon.svg";
import reminderIcon from "../../assets/svg/reminder-bel.svg";
import renewal from "../../assets/svg/renewal.svg";
import email from "../../assets/svg/mail.svg";
import phone from "../../assets/svg/phone.svg";
import user from "../../assets/svg/user.svg";
import AddRemainderModal from "./add-remainder-modal.js";
import DOMPurify from "dompurify";
import { createAssetApi, getAssetApi, getAssetAttachmentApi, getAssetProfileApi, getAssetReminderApi, getAssetTagApi, getDeleteApi, updateAssetApi, uploadAttachmentApi, uploadProfileAttachmentApi } from "./asset-api.js";
import SearchWithStaticArray from "../searchbox/searchWithStatic.js";
import moment from "moment";
import edit from "../../assets/svg/edit-blue.svg";
import del from "../../assets/svg/delete-red.svg";
import uploadFile from "../../assets/svg/upload-file.svg";
import close from "../../assets/svg/close-chip.svg";
import SearchWithFreeTextAPI from "../searchbox/searchbox-free-text.js";

export default function AssetCreate() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};
  const [validations, setValidations] = useState({
    name: "",
    asset_type: "",
    tag: "",
    usage_type: "",
    uom_id: "",
    consumption: "",
    description: "",
    location_id: "",
    department_id: "",
    status: "",
    assigned_to: "",
    assigned_on: "",
    managed_by: "",
    end_of_life: "",
    onboard_data: "",
    invoice_number: "",
    serial_number: "",
    depreciation_percentage: "",
    cost: "",
    vendor_id: "",
    warranty_value: "",
    warranty_unit: "",
    invoice_date: "",
  });

  const [reminderError, setReminderError] = useState("");

  const [statusList, setStatusList] = useState([
    { value: "Allocated", label: "Allocated" },
    { value: "Non-Allocated", label: "Non-Allocated" },
    { value: "Missing", label: "Missing" },
    { value: "Repair", label: "Repair" },
    { value: "Scrap", label: "Scrap" },
  ]);
  const [assetTag, setAssetTag] = useState("");
  const [workspcae, setWorkspace] = useState("");
  const [assetName, setAssetName] = useState("");
  const [assetTypeOption, setAssetTypeOption] = useState("");
  const [uomOption, setUOMOption] = useState(null);
  const [consumption, setConsumption] = useState("");
  const [description, setDescription] = useState("");
  const [managedByOption, setManagedByOption] = useState(null);
  const [usedByOption, setUsedByOption] = useState(null);
  const [statusOption, setStatusOption] = useState(null);
  const [locationOption, setLocationOption] = useState(null);
  const [departmentOption, setDepartmentOption] = useState(null);
  const [assignedDate, setAssignedDate] = useState("");
  const [assignedTime, setAssignedTime] = useState("");
  const [endOfLifedDate, setEndOfLifeDate] = useState("");
  const [onboardData, setOnBoardData] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [assetCost, setAssetCost] = useState("");
  const [depreciation, setDepreciation] = useState("");
  const [vendor, setVendor] = useState("");
  const [vendorContact, setVendorContact] = useState("");
  const [vendorOption, setVendorOption] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState("");
  const [warrantyPeriod, setWarrantyPeriod] = useState("");
  const [warrantyUnit, setWarrantyUnit] = useState("Year");
  const [showReminder, setShowReminder] = useState(false);
  const [reminderList, setReminderList] = useState([]);
  const [editReminder, setEditReminder] = useState(null);
  const [editReminderIndex, setEditReminderIndex] = useState(null);

  const [base64ProfileFile, setBase64ProfileFile] = useState("");
  const [urlImageProfile, setUrlImageProfile] = useState("");
  const [base64FileList, setBase64FileList] = useState([]);
  const [urlImageList, setUrlImageList] = useState([]);
  const [removedImageList, setRemovedImageList] = useState([]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const handleAssetTypeDropdownChange = (option) => {
    setAssetTypeOption(option.value);
  };
  const handleAssetTypeOnChange = (term) => {
    setAssetTypeOption(term);
  };

  /*   const handleTypeDropdownChange = (option) => {
    setAssetTypeOption(option);
  }; */
  const handleUOMDropdownChange = (option) => {
    setUOMOption(option);
  };
  const handleManagedByDropdownChange = (option) => {
    setManagedByOption(option);
  };
  const handleUsedByDropdownChange = (option) => {
    setUsedByOption(option);
  };
  const handleStatusDropdownChange = (option) => {
    setStatusOption(option);
  };
  const handleLocationDropdownChange = (option) => {
    setLocationOption(option);
  };
  const handleDepartmentDropdownChange = (option) => {
    setDepartmentOption(option);
  };
  const handleVendorDropdownChange = (option) => {
    setVendorOption(option);
  };

  useEffect(() => {
    if (id != null) {
      getAssetData();
      getAssetProfile();
      getAttachmentList();
      getReminderList();
    }
  }, [id]);

  const submitAsset = async () => {
    const dataBeforeSanitize = {
      name: assetName,
      asset_type: assetTypeOption != null ? assetTypeOption : "",
      tag: assetTag,
      usage_type: workspcae,
      uom_id: uomOption != null ? uomOption.value : "",
      consumption: consumption,
      description: description,
      location_id: locationOption != null ? locationOption.value : "",
      department_id: departmentOption != null ? departmentOption.value : "",
      status: statusOption != null ? statusOption.value : "",
      assigned_to: usedByOption != null ? usedByOption.value : "",
      assigned_on: assignedDate !== "" ? `${assignedDate} ${assignedTime !== "" ? assignedTime + ":00" : "00:00:00"}` : "",
      managed_by: managedByOption != null ? managedByOption.value : "",
      end_of_life: endOfLifedDate,
      onboard_data: onboardData,
      invoice_number: invoiceNumber,
      serial_number: serialNumber,
      depreciation_percentage: depreciation,
      cost: assetCost,
      vendor_id: vendorOption != null ? vendorOption.value : "",
      warranty_value: warrantyPeriod,
      warranty_unit: warrantyUnit, //Week|Month|Year
      invoice_date: invoiceDate,
      reminders: reminderList,
    };
    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });
    if (id == null && id !== "") {
      const response = await createAssetApi(dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.success === true) {
          setReminderError(""); // Clear reminder error on success
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.success);
          handleSnackbarShow();
          if (base64ProfileFile != null && base64ProfileFile !== "") {
            uploadProfileAttachment(response.data.id);
          }
          if (base64FileList.length > 0) {
            uploadAttachment(response.data.id);
          } else {
            navigate(-1);
          }
        }
      }
      if (response.status === 400) {
        // Extract and process validation errors
        const errors = response.data.error || {};
        let reminderValidationError = "";

        // Check for reminder errors
        Object.entries(errors).forEach(([key, value]) => {
          if (key.includes("reminders")) {
            const errorMsg = Array.isArray(value) && value.length > 0 ? value[0] : value;
            reminderValidationError = errorMsg;
          }
        });

        // Set reminder error
        if (reminderValidationError) {
          setReminderError(reminderValidationError);
        }

        // Show general validation error message in snackbar
        setSnackbarMessage(response.data.message || "Validation error");
        setSnackbarStatus(false);
        handleSnackbarShow();

        // Still update field-level validations
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            name: "",
            location_id: "",
            available_in_time: "",
            available_out_time: "",
            description: "",
            display_name: "",
            users: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            // Only set if it's a direct field (not nested like reminders.0.field)
            if (!key.includes(".")) {
              validationTemp[key] = value.length === 0 ? "" : value[0];
            }
          });
          console.log("validationTemp...", validationTemp);
          setValidations(validationTemp);
        });
      }
    } else {
      const response = await updateAssetApi(id, dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.success === true) {
          setReminderError(""); // Clear reminder error on success
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.success);
          handleSnackbarShow();
          if (base64ProfileFile != null && base64ProfileFile !== "") {
            uploadProfileAttachment(id);
          }
          if (base64FileList.length > 0) {
            uploadAttachment(response.data.id);
          } else {
            navigate(-1);
          }
        }
      }
      if (response.status === 400) {
        // Extract and process validation errors
        const errors = response.data.error || {};
        let reminderValidationError = "";

        // Check for reminder errors
        Object.entries(errors).forEach(([key, value]) => {
          if (key.includes("reminders")) {
            const errorMsg = Array.isArray(value) && value.length > 0 ? value[0] : value;
            reminderValidationError = errorMsg;
          }
        });

        // Set reminder error
        if (reminderValidationError) {
          setReminderError(reminderValidationError);
        }

        // Show general validation error message in snackbar
        setSnackbarMessage(response.data.message || "Validation error");
        setSnackbarStatus(false);
        handleSnackbarShow();

        // Still update field-level validations
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            name: "",
            location_id: "",
            available_in_time: "",
            available_out_time: "",
            description: "",
            display_name: "",
            users: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            // Only set if it's a direct field (not nested like reminders.0.field)
            if (!key.includes(".")) {
              validationTemp[key] = value.length === 0 ? "" : value[0];
            }
          });
          console.log("validationTemp...", validationTemp);
          setValidations(validationTemp);
        });
      }
    }
  };
  const uploadAttachment = async (id) => {
    const response = await uploadAttachmentApi(id, { attachments: base64FileList });
    if (response.status === 200) {
      if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        navigate(-1);
      }
    }
  };
  const uploadProfileAttachment = async (id) => {
    const response = await uploadProfileAttachmentApi(id, { image: base64ProfileFile });
    if (response.status === 200) {
      if (response.data.success === true) {
      }
    }
  };

  const getAssetTag = async () => {
    if (assetTypeOption != null) {
      const response = await getAssetTagApi(assetTypeOption);
      if (response.data.success === true) {
        setAssetTag(response.data.code ?? "");
      }
    }
  };
  const getAssetData = async () => {
    const response = await getAssetApi(id);
    if (response?.data?.success === true) {
      const asstData = response.data.asset ?? {};
      setAssetName(asstData.name ?? "");
      setAssetTypeOption(asstData.asset_type !== null ? asstData.asset_type : "");
      setAssetTag(asstData.asset_tag ?? "");
      setWorkspace(asstData.usage_type ?? "Internal");
      setUOMOption(asstData.uom_id !== null ? { value: asstData.uom_id, label: asstData.uom } : null);
      setConsumption(asstData.consumption ?? "");
      setDescription(asstData.description ?? "");
      setStatusOption(asstData.asset_status !== null ? { value: asstData.asset_status, label: asstData.asset_status } : null);
      setLocationOption(asstData.location_id !== null ? { value: asstData.location_id, label: asstData.location } : null);
      setDepartmentOption(asstData.department_id !== null ? { value: asstData.department_id, label: asstData.department } : null);
      setUsedByOption(asstData.assigned_to_value !== null ? { value: asstData.assigned_to_value, label: asstData.assigned_to_label } : null);
      setManagedByOption(asstData.managed_by_value !== null ? { value: asstData.managed_by_value, label: asstData.managed_by_label } : null);
      if (asstData.assigned_on != null && asstData.assigned_on !== "") {
        const assignedDate = moment(asstData.assigned_on).format("YYYY-MM-DD"); // "July 8, 2025"
        const assignedTime = moment(asstData.assigned_on).format("hh:mm");
        console.log(assignedTime);
        setAssignedDate(assignedDate);
        setAssignedTime(assignedTime);
      }
      if (asstData.eol !== null && asstData.eol !== "") {
        const eol = moment(asstData.eol).format("YYYY-MM-DD");
        setEndOfLifeDate(eol);
      }
      setOnBoardData(asstData.onboard_data ?? "");
      setInvoiceNumber(asstData.invoice_number ?? "");
      setSerialNumber(asstData.serial_number ?? "");
      setAssetCost(asstData.cost ?? "");
      setDepreciation(asstData.depreciation_percentage ?? "");
      setVendorOption(asstData.vendor_value !== null ? { value: asstData.vendor_value, label: asstData.vendor_label } : null);
      setInvoiceDate(asstData.invoice_date ?? "");
      setWarrantyUnit(asstData.warranty_unit ?? "");
      setWarrantyPeriod(asstData.warranty_value ?? "");
      setReminderList(asstData.reminders ?? []);
    }
  };

  const getAssetProfile = async () => {
    const response = await getAssetProfileApi(id);
    if (response?.data?.success === true) {
      setUrlImageProfile(response.data.profile);
    }
  };
  const getAttachmentList = async () => {
    const response = await getAssetAttachmentApi(id);
    if (response?.data?.success === true) {
      setUrlImageList(response.data.attachments);
    }
  };
  const getReminderList = async () => {
    const response = await getAssetReminderApi(id);
    if (response?.data?.success === true) {
      setReminderList(response.data.reminders);
    }
  };

  useEffect(() => {
    if (editReminder !== null) {
      setShowReminder(true);
    }
  }, [editReminder]);

  const onSuccessReminder = async (response) => {
    if (editReminderIndex === null) {
      setReminderList([...reminderList, response]);
    }
    if (editReminderIndex !== null) {
      const tempRem = [...reminderList];
      tempRem[editReminderIndex] = response;
      setReminderList(tempRem);
    }
    setShowReminder(false);
    setEditReminder(null);
    setEditReminderIndex(null);
  };

  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file /* && file.type.startsWith("image/") */) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        const tempBase64FileList = [...base64FileList];
        tempBase64FileList.push(base64String);
        setBase64FileList(tempBase64FileList);
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select a valid image file.");
    }
  };
  const deleteAttachmentApi = async (id) => {
    try {
      const response = await getDeleteApi(`asset/attachment/${id}`);

      if (response?.status === 200 || response?.status === 500) {
        getAttachmentList();
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const deleteReminderApi = async (id) => {
    try {
      const response = await getDeleteApi(`reminder/${id}`);

      if (response?.status === 200 || response?.status === 500) {
        getReminderList();
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const fileInputProfileRef = useRef(null);
  const handleProfileFileClick = () => {
    if (fileInputProfileRef.current) {
      fileInputProfileRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };

  const handleProfileFileChange = (event) => {
    const file = event.target.files[0];
    if (file /* && file.type.startsWith("image/") */) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        setBase64ProfileFile(base64String);
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select a valid image file.");
    }
  };
  return (
    <div className="px-2 py-2" style={{ width: "100%" }}>
      {showReminder === true && (
        <AddRemainderModal
          editReminder={editReminder}
          invoiceDate={invoiceDate}
          warrantyUnit={warrantyUnit}
          warrantyPeriod={warrantyPeriod}
          onSuccess={onSuccessReminder}
          onCancel={() => {
            setShowReminder(false);
            setEditReminder(null);
            setEditReminderIndex(null);
          }}
        />
      )}
      <div className="style-justify-between px-3" style={{ height: "40px" }}>
        <div className="style-justify-start">
          <img src={backarrow} alt="back" onClick={() => navigate(-1)} className="cursor-pointer" /* style={{ width: "14px", height: "14px" }} */ />
          <div className="ps-3 font-20-500-172B4D">New asset</div>
        </div>
        <div className="style-justify-start">
          <div className="style-justify-end">
            <div onClick={() => navigate(-1)} className="cancel-btn style-justify-center">
              Cancel
            </div>
            <div className="ms-2 save-btn style-justify-center cursor-pointer" onClick={() => submitAsset()}>
              {id != null ? "Update " : "Save "}
            </div>
          </div>
        </div>
      </div>
      <Row /* style={{width:'100%',}} */ className="px-2">
        <Col sm={12} md={9} xxl={8} className="mt-2">
          <div className="container-box">
            <div className="style-justify-between">
              <div className="style-justify-start">
                <div style={{ position: "relative" }}>
                  <div>
                    {urlImageProfile != null && urlImageProfile != "" && base64ProfileFile === "" && <img src={urlImageProfile != null && urlImageProfile != "" ? urlImageProfile : upload} alt="Upload" style={{ width: "80px", height: "80px" }} />}
                    {((base64ProfileFile != null && base64ProfileFile != "") || urlImageProfile === null || urlImageProfile === "") && <img src={base64ProfileFile != null && base64ProfileFile != "" ? base64ProfileFile : upload} alt="Upload" style={{ width: "80px", height: "80px" }} />}
                  </div>
                  {((base64ProfileFile != null && base64ProfileFile !== "") || (urlImageProfile != null && urlImageProfile !== "")) && (
                    <img
                      src={close}
                      alt=""
                      style={{ position: "absolute", top: "2px", right: "2px", cursor: "pointer" }}
                      onClick={() => {
                        setBase64ProfileFile("");
                        setUrlImageProfile("");
                        if (id != null) {
                          uploadProfileAttachment(id);
                        }
                      }}
                    />
                  )}
                </div>
                <div className="ms-2">
                  <div className="upload-txt">Upload photo</div>
                  <div className="upload-desc-txt">Add an image of the asset, it's best if it has the same length and height</div>
                </div>
              </div>

              <Button onClick={handleProfileFileClick} className="mt-2 ms-2 choose-file-btn">
                Choose from files
              </Button>
              <input
                ref={fileInputProfileRef}
                type="file"
                accept=".jpg, .jpeg, .png, .pdf"
                onChange={handleProfileFileChange}
                style={{ display: "none" }} // Hide the actual file input
              />
            </div>
            <div className="mt-2 font-18-500-172B4D">Asset information</div>
            <Row>
              <Col sm={12} md={8} xxl={9} className="mt-2">
                <div className="field-title mb-1">
                  Name<span style={{ color: "#FF4444" }}>*</span>
                </div>
                <input type="text" placeholder="Enter here" className="input-field w-100" value={assetName} onChange={(e) => setAssetName(e.target.value)} />
                <span className="field-error">{validations.name}</span>
              </Col>
              <Col sm={12} md={4} xxl={3} className="mt-2">
                <div className="field-title mb-1">Type</div>
                <SearchWithFreeTextAPI onDropdownChange={handleAssetTypeDropdownChange} onChangeSearch={handleAssetTypeOnChange} apiUrl={apiUrl + `get_asset_type`} searchLimit={0} placeholder={"TSelect"} selectedValue={assetTypeOption} />
                <span className="field-error">{validations.asset_type}</span>
              </Col>
              <Col xs={12} sm={12} md={3} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-2">
                  Tag<span style={{ color: "#FF4444" }}>*</span>
                </div>
                <div className="style-justify-start cursor-pointer">
                  <input type="text" placeholder="Enter tag" className="input-field w-100" value={assetTag} onChange={(e) => setAssetTag(e.target.value)} />
                  <div
                    onClick={() => {
                      getAssetTag();
                    }}
                    className="ms-1 get-tag style-justify-center"
                  >
                    Get
                  </div>
                </div>
                <span className="field-error">{validations.tag}</span>
              </Col>
              <Col xs={12} sm={12} md={3} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-2">Workspace</div>
                <select
                  className="input-field w-100"
                  value={workspcae || "Internal"}
                  onChange={(e) => {
                    setWorkspace(e.target.value);
                  }}
                  style={{ gap: "8px", backgroundColor: "#FFFFFF" }}
                >
                  <option value="Internal">Internal</option>
                  <option value="External">External</option>
                </select>
                <span className="field-error">{validations.usage_type}</span>
              </Col>
              <Col xs={12} sm={12} md={3} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">UOM</div>
                <SearchWithAPI onDropdownChange={handleUOMDropdownChange} apiUrl={adminApiUrl + "get_uom"} params={{}} placeholder={"Select"} selectedOption={uomOption} />
                <span className="field-error">{validations.uom_id}</span>
              </Col>

              <Col xs={12} sm={12} md={3} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">Consumption</div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field w-100"
                  value={consumption}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setConsumption(value);
                  }}
                />
                <span className="field-error">{validations.consumption}</span>
              </Col>

              <Col sm={12} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">Description</div>
                <input type="text" placeholder="Enter here" className="input-field w-100" value={description} onChange={(e) => setDescription(e.target.value)} />
                <span className="field-error">{validations.description}</span>
              </Col>
            </Row>
          </div>
        </Col>
        <Col sm={12} md={3} xxl={4} className="mt-2">
          <div className="container-box" style={{ height: "100%" }}>
            <div className="font-18-500-172B4D">Add attachments</div>
            <div onClick={handleFileClick} className="mt-2 px-2 py-4 cursor-pointer" style={{ borderRadius: "16px", border: "1px solid #EBEBEB", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
              <img src={uploadFile} alt="file" />
              <div className="mt-2 font-14-500-3B84E6">Choose file</div>
              <input
                ref={fileInputRef}
                type="file"
                accept=".jpg, .jpeg, .png, .pdf"
                onChange={handleFileChange}
                style={{ display: "none" }} // Hide the actual file input
              />
            </div>
            <div className="d-flex flex-wrap justify-content-start align-items-center gap-2">
              {urlImageList.map((urlImage, index) => (
                <div key={"url-image-" + index} className="mt-2 style-justify-between" style={{ width: "241px", height: "52px", borderRadius: "12px", padding: "8px 12px", background: "#F8F8F8" }}>
                  <div className="style-justify-start">
                    <img src={urlImage != null && urlImage !== "" ? urlImage.file_path : ""} alt="complaint" style={{ width: "42px", height: "42px", borderRadius: "14px" }} />
                  </div>
                  <div>
                    <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                      <img
                        src={close}
                        alt=""
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          deleteAttachmentApi(urlImage.id);
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
              {base64FileList.map((baseImage, index) => (
                <div key={"base-image-" + index} className="mt-2 style-justify-between" style={{ width: "241px", height: "52px", borderRadius: "12px", padding: "8px 12px", background: "#F8F8F8" }}>
                  <div className="style-justify-start">
                    <img src={baseImage != null && baseImage !== "" ? baseImage : ""} alt="complaint" style={{ width: "42px", height: "42px", borderRadius: "14px" }} />
                  </div>
                  <div>
                    <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                      <img
                        src={close}
                        alt=""
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          const tempImageList = [...base64FileList];
                          tempImageList.splice(index, 1);
                          setBase64FileList(tempImageList);
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Col>
        <Col sm={12} md={6} className="mt-2">
          <div className="container-box">
            <div className="mt-2 font-18-500-172B4D">Maintenance information</div>
            <Row className="mt-2">
              <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">Location</div>
                <SearchWithAPI onDropdownChange={handleLocationDropdownChange} apiUrl={adminApiUrl + "get_location"} params={{}} placeholder={"Select"} selectedOption={locationOption} />
                <span className="field-error">{validations.location_id}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">Department</div>
                <SearchWithAPI onDropdownChange={handleDepartmentDropdownChange} apiUrl={adminApiUrl + "get_department"} params={{}} placeholder={"Select"} selectedOption={departmentOption} />
                <span className="field-error">{validations.department_id}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">User by</div>
                <SearchWithAPI onDropdownChange={handleUsedByDropdownChange} apiUrl={adminApiUrl + "get_employee"} params={{}} placeholder={"Select"} selectedOption={usedByOption} />
                <span className="field-error">{validations.assigned_to}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">
                  Status<span style={{ color: "#FF4444" }}>*</span>
                </div>
                <SearchWithStaticArray onDropdownChange={handleStatusDropdownChange} options={statusList} placeholder={"Select"} selectedOption={statusOption} />
                <span className="field-error">{validations.status}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">Managed by</div>
                <SearchWithAPI onDropdownChange={handleManagedByDropdownChange} apiUrl={adminApiUrl + "get_employee"} params={{}} placeholder={"Select"} selectedOption={managedByOption} />
                <span className="field-error">{validations.managed_by}</span>
              </Col>

              <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">Assigned on</div>
                <Row className="mt-1" style={{ width: "100%" }}>
                  <Col sm={7}>
                    <div>
                      <input
                        type="date"
                        placeholder="Enter here"
                        className="input-field w-100"
                        value={assignedDate}
                        onChange={(event) => {
                          setAssignedDate(event.target.value);
                        }}
                      />
                    </div>
                  </Col>
                  <Col sm={5} className="px-0">
                    <div>
                      <input
                        type="time"
                        placeholder="Enter here"
                        className="input-field w-100"
                        value={assignedTime}
                        onChange={(event) => {
                          setAssignedTime(event.target.value);
                        }}
                      />
                    </div>
                  </Col>

                  <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444" }}>{validations.in_time}</span>
                </Row>
                <span className="field-error">{validations.assigned_on}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">End of Life</div>
                <input
                  type="date"
                  placeholder="Enter here"
                  className="input-field w-100"
                  value={endOfLifedDate}
                  onChange={(event) => {
                    setEndOfLifeDate(event.target.value);
                  }}
                />
                <span className="field-error">{validations.end_of_life}</span>
              </Col>

              <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">Onboard data</div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field w-100"
                  value={onboardData}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setOnBoardData(value);
                  }}
                />
                <span className="field-error">{validations.onboard_data}</span>
              </Col>
            </Row>
          </div>
        </Col>
        <Col sm={12} md={6} className="mt-2">
          <div className="container-box">
            <div className="mt-2 font-18-500-172B4D">Invoice information</div>
            <Row className="mt-2">
              <Col sm={12} md={6} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">Invoice number</div>
                <input type="text" placeholder="Enter here" className="input-field w-100" value={invoiceNumber} onChange={(e) => setInvoiceNumber(e.target.value)} />
                <span className="field-error">{validations.invoice_number}</span>
              </Col>

              <Col sm={12} md={6} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">Serial number</div>
                <input type="text" placeholder="Enter here" className="input-field w-100" value={serialNumber} onChange={(e) => setSerialNumber(e.target.value)} />
                <span className="field-error">{validations.serial_number}</span>
              </Col>
              <Col sm={12} md={6} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">Cost</div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field w-100"
                  value={assetCost}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setAssetCost(value);
                  }}
                />
                <span className="field-error">{validations.cost}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">Depreciation per year</div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field w-100"
                  value={depreciation}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setDepreciation(value);
                  }}
                />
                <span className="field-error">{validations.depreciation_percentage}</span>
              </Col>

              <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">Vendor</div>
                {/*  <input type="text" placeholder="Enter here" className="input-field w-100" value={vendor} onChange={(e) => setVendor(e.target.value)} /> */}
                <SearchWithAPI onDropdownChange={handleVendorDropdownChange} apiUrl={apiUrl + "get_vendor"} params={{}} placeholder={"Select"} selectedOption={vendorOption} />
                <span className="field-error">{validations.vendor_id}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">Invoice Date</div>
                <input
                  type="date"
                  placeholder="Enter here"
                  className="input-field w-100"
                  value={invoiceDate}
                  onChange={(event) => {
                    setInvoiceDate(event.target.value);
                  }}
                />
                <span className="field-error">{validations.invoice_date}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-1">Warranty Period</div>
                <div className="style-justify-start">
                  <input
                    style={{ flex: 2 }}
                    type="text"
                    placeholder="Enter here"
                    className="input-field w-100"
                    value={warrantyPeriod}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setWarrantyPeriod(value);
                    }}
                  />
                  <select style={{ flex: 1 }} value={warrantyUnit} className="ms-1 input-field w-100 px-2 py-2" onChange={(e) => setWarrantyUnit(e.target.value)}>
                    <option value="Week">Week</option>
                    <option value="Month">Month</option>
                    <option value="Year">Year</option>
                  </select>
                </div>

                <span className="field-error">{validations.warranty_value}</span>
              </Col>
            </Row>
          </div>
        </Col>
        <div style={{ width: "calc(100vw - 65px)", marginLeft: "0px" }} className="mt-2">
          <div className="container-box">
            <div className="style-justify-between">
              <div className="mt-2 font-18-500-172B4D">Remainders</div>
              <div className="style-justify-start">
                <Button
                  className="mt-2 add-reminder-btn ms-2"
                  onClick={() => {
                    setReminderError(""); // Clear error when adding new reminder
                    setShowReminder(true);
                  }}
                >
                  <img src={reminder} alt="reminder" style={{ width: 16, height: 16, marginRight: 6 }} />
                  Add reminder
                </Button>
              </div>
            </div>
            {reminderList?.map((reminder, i) => (
              <div className="mt-2" style={{ border: "1px solid #EBEBEB", padding: "14px", borderRadius: "16px" }}>
                <div className="style-justify-start">
                  <div className="remainder-box style-justify-center">
                    <img src={reminderIcon} alt="Reminder Icon" />
                  </div>
                  <div className="ms-2" style={{ flex: 1 }}>
                    <div className="style-justify-start">
                      <div className="reminder-title">{reminder.trigger_seq ?? ""}</div>
                      <div className="mx-3" style={{ width: "4px", height: "4px", borderRadius: "100px", background: "#D9D9D9" }}></div>
                      <div className="ms-1 style-justify-center px-2 " style={{ background: "#E9F1FF", borderRadius: "12px", paddingTop: "4px", paddingBottom: "4px", fontSize: "12px", fontWeight: "400", color: "#172B4D" }}>
                        {reminder.type ?? ""}
                      </div>
                    </div>
                    {/*  <div className="style-justify-start"> <img src={renewal} alt="renewal" style={{ marginRight: 6 }} /> <div className="reminder-subtitle">Warranty renewal information</div></div> */}
                  </div>
                  <div className="style-justify-start">
                    <button
                      onClick={() => {
                        setEditReminder(reminder);
                        setEditReminderIndex(i);
                      }}
                      className="icon-btn edit-btn"
                      title="Edit"
                    >
                      <img src={edit} alt="Edit" className="icon-img" />
                    </button>
                    <button
                      onClick={() => {
                        if (reminder.id != null && reminder.id != "") {
                          deleteReminderApi(reminder.id);
                        } else {
                          const updatedItems = reminderList.filter((_, index) => index !== i);
                          setReminderList(updatedItems);
                        }
                      }}
                      className="ms-2 icon-btn delete-btn"
                      title="Delete"
                    >
                      <img src={del} alt="Delete" className="icon-img" />
                    </button>
                  </div>
                </div>

                <div className="mt-2 remainder-config style-justify-between" style={{ flexWrap: "wrap" }}>
                  <div>
                    <div className="style-justify-start">
                      <img src={email} alt="Email" />
                      <span className="ms-2 alert-title">EMAIL</span>
                    </div>
                    <div className="mt-2">
                      {reminder.emails?.map((email, i) => (
                        <div className="font-13-400-172B4D">{email}</div>
                      ))}
                    </div>
                  </div>
                  <div className="vertical-divider"> </div>
                  <div>
                    <div className="style-justify-start">
                      <img src={phone} alt="MOBILE" />
                      <span className="ms-2 alert-title">MOBILE NUMBER</span>
                    </div>
                    <div className="mt-2">
                      {reminder.mobile_numbers?.map((mobile, i) => (
                        <div className="font-13-400-172B4D">{mobile}</div>
                      ))}
                    </div>
                  </div>

                  <div className="vertical-divider"> </div>

                  <div>
                    <div className="style-justify-start">
                      <img src={user} alt="USER" />
                      <span className="ms-2 alert-title">USER</span>
                    </div>
                    <div className="mt-2">
                      {reminder.user_labels?.map((user, i) => (
                        <div className="font-13-400-172B4D">{user.label}</div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {reminderError && (
              <div className="mt-2">
                <span className="field-error">{reminderError}</span>
              </div>
            )}
          </div>
        </div>
      </Row>

      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <div></div>
    </div>
  );
}
